<template>
  <FKBreadCrumb :page="user_fullname">
    <!-- <FKBreadCrumbItem :page="$t('page.system_users')" to="/system-users" /> -->
  </FKBreadCrumb>
  <div class="row">
    <div class="col-xxl-5">
      <UserAnagraph />
    </div>
    <div class="col-xxl-7">
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import UserAnagraph from "@/components/FK/UserInfo/UserAnagraph.vue";
import { UserInfo } from "@/utils/models/user.model";

export default defineComponent({
  name: "UserPage",
  components: {
    FKBreadCrumb,
    // FKBreadCrumbItem,
    UserAnagraph
  },
  computed: {
    user_fullname(): string {
      const user = this.$route.meta.user as UserInfo;
      const fullname = `${user?.firstname ?? ''} ${user?.lastname ?? ''}`;
      return fullname.trim() === '' ? this.$t('page.user') : fullname;
    }
  }
});
</script>